<template>
  <div class="station-header-container">
    <div class="header-left">
      <i class="live-img"></i>
      <span class="live-name">{{ liveDetail.liveName }}</span>
      <span class="live-status">{{ liveStatusText[liveDetail.status] }}</span>
    </div>
    <!-- <div class="header-right">头像</div> -->
  </div>
</template>

<script>
export default {
  name: 'GuideStation', // 手工导播
  props: {
    liveDetail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: {
  },
  data () {
    return {
      liveStatusText: {
        0: '未开始直播',
        1: '直播进行中',
        2: '直播已结束'
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .station-header-container{
    background: #fff;
    height: 5rem;
    padding: 0 3.2rem; // 1rem 3.2rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.6rem;
    .header-left{
      flex: 1;
      display: flex;
      align-items: center;
      .live-img{
        width: 4rem;
        height: 4rem;
        background-color: #F6F8FA;
        background-size: cover;
        border-radius: 100%;
        background-image: url('~@/assets/img/login-logo.png');
        background-repeat: no-repeat;
      }
      .live-name{
        color: #1E2228;
        font-size: 1.6rem;
        font-weight: 500;
        margin-left: 0.6rem;
      }
      .live-status{
        font-size: 1.4rem;
        color: #6E7785;
        margin-left: 1rem;
      }
    }
    // .header-right{
    //   width: 20%;
    //   min-width: 6rem;
    //   border: 1px solid red;
    // }
  }
</style>